import React, { useContext, useCallback, useState, useRef, useEffect } from 'react';
import { TreeContext } from '../../context/TreeContext';
import TreeControlsLeft from './TreeControlsLeft';
import TreeControlsRight from './TreeControlsRight';
import '../../styles/components/ControlCenter.css';

const TreeControlCenter = React.memo(() => {
  const { state, dispatch } = useContext(TreeContext);
  const [activeColorField, setActiveColorField] = useState(null);
  const colorPickerRef = useRef(null);

  // General handler for input changes
  const handleChange = useCallback((field) => (e) => {
    // Handle different value types
    let value;
    if (e.target.type === 'number') {
      value = parseInt(e.target.value);
    } else if (e.target.type === 'range') {
      value = parseFloat(e.target.value);
    } else {
      value = e.target.value;
    }
    
    dispatch({ field, value });
  }, [dispatch]);

  // Handler for color changes
  const handleColorChange = useCallback((color) => {
    if (activeColorField) {
      dispatch({ field: activeColorField, value: color });
    }
  }, [activeColorField, dispatch]);

  // Handler for toggling boolean values
  const handleToggle = useCallback((field) => () => {
    dispatch({ field, value: !state[field] });
  }, [state, dispatch]);

  // Handler for regenerating colors
  const handleRegenerateColors = useCallback(() => {
    dispatch({ field: 'regenerateColors' });
  }, [dispatch]);

  // Close color picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setActiveColorField(null);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="ControlCenter">
      <TreeControlsLeft 
        handleChange={handleChange}
        handleToggle={handleToggle}
      />
      <TreeControlsRight 
        handleChange={handleChange}
        handleToggle={handleToggle}
        handleColorChange={handleColorChange}
        handleRegenerateColors={handleRegenerateColors}
        activeColorField={activeColorField}
        setActiveColorField={setActiveColorField}
      />
    </div>
  );
});

export default TreeControlCenter; 